export default __webpack_public_path__ + "static/media/package.3b5b4855.png";